import { render } from "./nuevoUsuarioPlataforma.vue?vue&type=template&id=0616f4b0&scoped=true"
import script from "./nuevoUsuarioPlataforma.vue?vue&type=script&lang=js"
export * from "./nuevoUsuarioPlataforma.vue?vue&type=script&lang=js"

import "./nuevoUsuarioPlataforma.vue?vue&type=style&index=0&id=0616f4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0616f4b0"]])

export default __exports__